// V1.37.11 · Las autorizaciones DGT y Menor se han movido a Documentos
// (misma pauta que el Justificante de Ausencia). Este catálogo ahora solo
// contiene el Contrato completo — el resto de documentos independientes
// se generan desde Documentos, con su propia firma manuscrita.
export const CONTRACT_DOCS = [
  { key: "contrato", label: "Contrato completo", icon: "FileText" },
];

export function isMinor(birth_date) {
  if (!birth_date) return false;
  const d = new Date(birth_date);
  if (Number.isNaN(d.getTime())) return false;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
  return age < 18;
}
